<template>
  <transition name="notes-modal">
    <div v-if="patientInfo && showNotes" class="modal-backdrop notes-backdrop" @click="shouldCloseWithoutSaving">
      <div class="notes-modal" @click.stop>
        <loading-screen v-show="isFetching || savingNote" />
        <notes-overview
          v-if="!isFetching"
          ref="notes-overview"
          :picture="patientInfo.picture"
          :gender="patientInfo.gender"
          :name="patientInfo.name"
          :vip="patientInfo.vip || patientInfo.is_vip_account"
          :high-risk="patientInfo.highRisk || patientInfo.patient_is_high_risk"
          :notes="patientNotes"
          :saving-note="savingNote"
          @should-close-without-saving="shouldCloseWithoutSaving"
          @save-note="saveNote"
          @delete-note="deleteNote"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import NotesOverview from '@ui-kit/components/notes/NotesOverview.vue'
import LoadingScreen from '@/components/feedbacks/LoadingScreen.vue'

export default {
  name: 'NotesModal',
  components: {
    NotesOverview,
    LoadingScreen,
  },
  data() {
    return {
      savingNote: false,
    }
  },
  computed: {
    ...mapGetters({
      patientNotes: 'notes/getNotes',
      patientInfo: 'notes/getCurrentPatient',
    }),
    ...mapGetters('notes', ['isFetching']),
    showNotes() {
      return this.$store.getters['general/isModalOpened']('notes')
    },
  },
  methods: {
    ...mapActions('notes', ['updateNote', 'createNote', 'deleteNote']),
    async shouldCloseWithoutSaving() {
      let shouldSave = false
      const currentNote = this.$refs['notes-overview']?.currentNote

      this.$store.commit('general/toggleShowModal', { notes: false })

      if (currentNote?.id) {
        const prevNote = this.patientNotes.find((note) => note.id === currentNote.id)

        shouldSave = prevNote && prevNote.title !== currentNote.title || prevNote.body !== currentNote.body
      } else {
        shouldSave = !!currentNote?.body
      }

      if (shouldSave) {
        await this.saveNote(currentNote)
        this.$notify.success(this.$t('copy_2687'))
      } else {
        this.$refs['notes-overview'].closeOpenNote()
      }
    },
    async saveNote(currentNote) {
      this.savingNote = true

      if (!currentNote.title) {
        currentNote.title = this.$t('copy_2676')
      }
      await (currentNote.id ? this.updateNote(currentNote) : this.createNote(currentNote))
      this.savingNote = false
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-backdrop.notes-backdrop {
  background-color: transparent;
}

.notes-modal-enter,
.notes-modal-leave-to {
  opacity: 0;
  transform: translateX(110%);
}

.notes-modal-enter-to,
.notes-modal-leave {
  opacity: 1;
  transform: translateX(0);
}

.notes-modal-enter-active {
  transition: all 0.3s ease-out;
}

.notes-modal-leave-active {
  transition: all 0.1s ease-in;
}
.notes-modal {
  position: fixed;
  bottom: 2.5rem;
  right: 2.5rem;
  z-index: 11;
  width: 23.75rem;
  height: 33.125rem;
  max-height: calc(100% - 7.5rem);
  background-color: $white;
  border-radius: 0.25rem;

  @media screen and (max-width: break-wuk('medium', 's')) {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 26;
    border-radius: 0;
    max-height: initial;
  }
}
</style>
